(function ($) {
    $.fn.styleSlider = function () {

        function slide(element, slider, value) {

            var range = $(slider).find(".ui-slider-range");
            range.removeClass("range-1").removeClass("range-2").removeClass("range-3").removeClass("range-4").removeClass("range-5").addClass("range-" + value);


            $(slider).find(".slider_marker").each(function () {
                var active = $(this).data("value") <= value ? true : false;

                if (active) {
                    $(this).addClass("active");

                } else {
                    $(this).removeClass("active");
                }

            });

            $(element).val(value).change();
          


        }

        function makeSlider(element) {
            var slider = $('<div class="slider" ></div>');
            var sliderTrack = $('<div class="sliderTrack" ></div>');
            $(slider).insertAfter(element);
            $(slider).append(sliderTrack);
            var marker1 = $('<div class="slider_marker marker_1" data-value="1">1</div>');
            var marker2 = $('<div class="slider_marker marker_2" data-value="2">2</div>');
            var marker3 = $('<div class="slider_marker marker_3" data-value="3">3</div>');
            var marker4 = $('<div class="slider_marker marker_4" data-value="4">4</div>');
            var marker5 = $('<div class="slider_marker marker_5" data-value="5">5</div>');
            $(slider).append(marker1);
            $(slider).append(marker2);
            $(slider).append(marker3);
            $(slider).append(marker4);
            $(slider).append(marker5);
            $(slider).append(element);
            $(element).addClass("hidden");

            var min = 1;
            var max = 5;


            var value = $(element).val();

            $(sliderTrack).slider({
                value: value,
                range: "min",
                min: min,
                max: max,
                step: 1,
                slide: function (event, ui) {
                    slide(element, slider, ui.value);

                }


            });
            $(sliderTrack).slider("value", value);
            slide(element, slider, value);
        }

        return this.each(function () {
            makeSlider(this);
        });


    };

})(jQuery);